import React, { useEffect } from 'react'
import Navbar2 from '../../components/ui/navbar/Navbar2'
import TietosuojaselosteHeader from '../../components/ui/tietoja.header/TietosuojaselosteHeader'
import Compbox from '../../components/ui/tietosuojaseloste.compbox/Compbox'
import Footer from '../../components/ui/footer/Footer'
import MapTo from '../../components/ui/map/MapTo'

export default function Tietoja() {
  useEffect(() => {     document.title = 'SL Health - Tietosuojaseloste';   }, [])
  return (
    <>
        <Navbar2/>
        <TietosuojaselosteHeader/>
        <Compbox/>
        <MapTo/>
        <Footer/>
    </>
  )
}
